import React from 'react';
import './ServicesHeroArea.css';

const ServicesHeroArea = () => {
    return (
        <section className="services-hero-section">
            <div className="services-bgOverlay">
                <div className="container">
                    <div className="services-content">
                        <h4>Home / Services</h4>
                        <h1>Services</h1>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServicesHeroArea;